import { isPaymentScheduleEnabled } from 'checkout/selectors/payment/paymentSchedule'
import Clickable from 'components/Common/Clickable'
import FormatCurrency from 'components/Common/FormatCurrency'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import CaptionTextBlock from 'components/Luxkit/TextBlocks/CaptionTextBlock'
import FormatPercent from 'components/utils/Formatters/FormatPercent'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import React, { MouseEventHandler, useCallback } from 'react'

interface Props {
  offer: App.Tours.TourV2Offer
  onInfoClick?: () => void
}

function TourDepositTag({ offer, onInfoClick }: Props) {
  const deposit = offer.paymentScheduleTemplate?.schedules[0]

  const handleInfoClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    onInfoClick!()
  }, [onInfoClick])

  if (!deposit) return null

  return <CaptionTextBlock
    variant="large"
    weight="bold"
    colour="highlight-secondary"
    endIcon={!!onInfoClick && <Clickable onClick={handleInfoClick}><LineInfoCircleIcon colour="neutral-one" /></Clickable>}
  >
    Secure with{' '}
    {deposit.amountType === 'percentage' && <FormatPercent value={deposit.amountValue} />}
    {deposit.amountType === 'fixed_amount' && <FormatCurrency value={deposit.amountValue} />}
    {' '}deposit
  </CaptionTextBlock>
}

export default withMountGuard(() => {
  return useAppSelector(isPaymentScheduleEnabled)
})(TourDepositTag)
